import iphoneSetting from '@/assets/images/onboarding/iphone/iphone-settings.png';
import iphoneSetting2 from '@/assets/images/onboarding/iphone/iphone-settings-2.png';
import iphoneSetting3 from '@/assets/images/onboarding/iphone/iphone-settings-3.png';

interface IphoneCarrierProps {
	setQr: React.Dispatch<React.SetStateAction<boolean>>;
}

const IphoneCarrierSetting = (props: IphoneCarrierProps) => {
	const handleConfirmation = () => {
		props.setQr(() => {
			const container = document.getElementById('scrollable-container');
			if (container) {
				container.scrollTop = 0;
			}
			return true;
		});
	};

	return (
		<div className="max-h-[500px] overflow-y-auto mx-auto w-full px-4 py-4 md:my-6 md:w-2/3 md:rounded-lg md:bg-white md:p-6 lg:w-[100%] border border-blue-200">
			<div>
				<h2 className="text-2xl font-bold text-base-content mb-4 md:mb-6">
					Disabling Live Voicemail
				</h2>
				<p className="text-base leading-relaxed text-base-content mb-4">
					The iPhone Live Voicemail setting will interfere with call forwarding. Before continuing
					we need to disable it. To do this:
				</p>

				<div className="grid place-items-center rounded-lg bg-base-100 p-4 lg:grid-cols-2 lg:gap-6">
					<div className="mb-4 text-center">
						<span className="font-semibold">Step 1.</span> Open the Settings app on your iPhone.
					</div>
					<div className="mb-6 w-full rounded-sm bg-gray-100 p-2 lg:mb-0">
						<img alt="Open the settings app" className="mx-auto h-32" src={iphoneSetting} />
					</div>

					<div className="mb-4 text-center">
						<span className="font-semibold">Step 2.</span> Navigate to the Live Voicemail settings
						by tapping on the search bar at the top of the settings app, and searching for “Live
						Voicemail”.
					</div>
					<div className="mb-6 w-full rounded-sm bg-gray-100 p-2 lg:mb-0">
						<img alt="Search for Live Voicemail" className="mx-auto h-32" src={iphoneSetting2} />
					</div>

					<div className="mb-4 text-center">
						<span className="font-semibold">Step 3.</span> Toggle the switch off to disable Live
						Voicemail as shown below.
					</div>
					<div className="mb-6 w-full rounded-sm bg-gray-100 p-2 lg:mb-0">
						<img alt="Disable Live Voicemail" className="mx-auto h-32" src={iphoneSetting3} />
					</div>
				</div>
				<div className="mt-4 text-base">
					<span className="font-semibold">Note:</span> Live Voicemail is not available on all
					iPhones. If there is no Live Voicemail option, you can{' '}
					<a
						onClick={() => props.setQr(true)}
						className="text-primary underline cursor-pointer font-medium"
					>
						continue
					</a>{' '}
					without needing to make any changes.
				</div>
				<button
					className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition-colors duration-200 w-full mt-4 text-lg"
					type="button"
					onClick={handleConfirmation}
				>
					I've disabled live voicemail
				</button>
			</div>
		</div>
	);
};

export default IphoneCarrierSetting;
